import { Injectable } from '@angular/core';

import { TipoAutorizacaoWeb, TokenAutorizacao, funcionalidadeDaRota } from 'src/app/models/User/MinhaAcaoPermissao.model';

/**
 * Guarda os tokens de autorização (modal de senha) até a requisição que os usa.
 * Fica separado do PermissaoAcessoService para o ApiService poder ler sem dependência circular.
 */
@Injectable({
    providedIn: 'root'
})
export class AutorizacaoTokenStore {
    private tokens = new Map<number, TokenAutorizacao>();

    guardar(funcionalidadeId: number, token: TokenAutorizacao): void {
        this.tokens.set(funcionalidadeId, token);
    }

    remover(funcionalidadeId: number): void {
        this.tokens.delete(funcionalidadeId);
    }

    limpar(): void {
        this.tokens.clear();
    }

    temTokenValido(funcionalidadeId: number): boolean {
        return this.obterValido(funcionalidadeId) !== undefined;
    }

    /**
     * Token a enviar no cabeçalho da requisição, se a rota for protegida e houver um token válido.
     * O de gravação é de uso único: sai da lista ao ser entregue. O de leitura continua valendo na tela.
     */
    obterParaRequisicao(metodo: string, rota: string): string | undefined {
        const funcionalidadeId = funcionalidadeDaRota(metodo, rota);
        if (funcionalidadeId === undefined) return undefined;

        const autorizacao = this.obterValido(funcionalidadeId);
        if (!autorizacao) return undefined;

        if (autorizacao.tipo === TipoAutorizacaoWeb.Gravacao) this.tokens.delete(funcionalidadeId);

        return autorizacao.token;
    }

    private obterValido(funcionalidadeId: number): TokenAutorizacao | undefined {
        const autorizacao = this.tokens.get(funcionalidadeId);
        if (!autorizacao) return undefined;

        if (new Date(autorizacao.expiresAt).getTime() <= Date.now()) {
            this.tokens.delete(funcionalidadeId);
            return undefined;
        }

        return autorizacao;
    }
}
